import {
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { CiCircleQuestion } from "react-icons/ci";
import { toast } from "react-toastify";

import {
  DarkGreenColorButton,
  GreenColorButton,
  PrimeGrayBorderColorButton,
  StatusStyle,
} from "../../../Components/MaterialButtonStyle/StyleButton";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../Components/MaterialTableStyle/MaterialTableStyle";
import CustomCheckBox from "../../../Components/CheckBox/CustomCheckBox";
import TextAreaField from "../../../Components/CustomInputs/TextArea";
import RightSideModal from "../../../Components/Modal/RightSideModal";
import { OnlyDateTimeConverter } from "../../../Components/Helpers/DateTimeConverter";
import CustomInput from "../../../Components/CustomInputs/CustomInputs";
import CustomDropDown from "../../../Components/DropDown/CustomDropDown";
import { RejectionsInfo } from "../../Settings/DataFile/Data";
import CustomModal from "../../../Components/Modal/CustomModal";
import { GetPublicURL, PostMethod } from "../../../Helper/api";

import CerificateModal from "./CerificateModal";

const TakePhysicalDataDetails = ({
  takePhysicalModal,
  setTakePhysicalModal,
  ClosePhysicalModal,
  physicalDetails,
  setPhysicalDetails,
  deficiencies,
  setDeficiencies,
  UpdateCandicateCerificate,
  remarks,
  setRemarks,
  roleCheckBoxData,
  HandleChandidateChange,
  applicationDetail,
  rejectReason,
  setRejectReason,
  isEdit,Selectedtests, setCertificateVerifyModal
}) => {
  const [confomationModal, setConfomationModal] = useState(false);
  const [ExaminedPlace, setExaminedPlace] = useState();
  const [Loading, setLoading] = useState(false);
  const userid = JSON.parse(localStorage.getItem("@users"));
  const [attachmentNewList,setattachmentNewList] = useState([])
  const [certificateImageModal, setCertificateImageModal] = useState(false);
  const [applicant_image, setapplicant_image] = useState();
  const [imageUrl, setImageUrl] = useState("");
  const [certificateName, setCertificateName] = useState("");
  const [fileExtentions,setfileExtentions] = useState("")
  const [selectedIndex, setSelectedIndex] = useState("");
  const [certificateSelectList, setCertificateSelectList] = useState({ "Yes": null, "No": null });

  useEffect(() => {
    if(applicationDetail?.physical_locations){
      if(applicationDetail.physical_locations[0]){
        setExaminedPlace(applicationDetail.physical_locations[0].value)
      }
    }
    if(applicationDetail?.applicant_image){
      getImagesDetails()
    }
    if(Selectedtests?.physical_test_attachment){
      setattachmentNewList(Selectedtests.physical_test_attachment)

    }
  }, [applicationDetail, physicalDetails,Selectedtests]);
  const getImagesDetails=async()=>{
    const response =await GetPublicURL(applicationDetail.applicant_image)
    setapplicant_image(response)
  }
  const UpdateModalPhysicalData = () => {
    if (physicalDetails?.length == 0) {
      toast.error("Physical Details is Empty");
      return;
    }
    if (!ExaminedPlace) {
      toast.error("Select the Examined Place");
      return;
    }
    try {
      physicalDetails.map((row) => {
  
        if (row.inputtype == "input") {
          if (!row?.FieldOfficerValue) {
            throw new Error(`Please Enter Field Officer Input for ${row.name}`);
          }
          if (row?.FieldOfficerValue?.trim()?.length == 0) {
            throw new Error(`Please Enter Field Officer Input for ${row.name}`);
          }
        }
        if (row.inputtype == "checkbox") {
          if (!row?.Yes && !row.No) {
            throw new Error(
              `Please Select Field Officer Input for ${row.name}`
            );
          }
        }
        if (!row?.Pass && !row.Fail) {
          throw new Error(`Please Select Status for ${row.name}`);
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    if (deficiencies) {
      if (deficiencies?.trim()?.length == 0) {
        toast.error("Please Enter Valid Deficiencies");
        return;
      }
    }
    if (!roleCheckBoxData.candidateFit && !roleCheckBoxData.candidateNotFit) {
      toast.error("Please Select Candidate Fitness");
      return;
    }
    if (roleCheckBoxData.candidateNotFit) {
      if (!rejectReason) {
        toast.error("Please Select Reject Reason");
        return;
      }
    }
    if (remarks) {
      if (remarks?.trim()?.length == 0) {
        toast.error("Please Enter Valid Remarks");
        return;
      }
    }
    if (physicalDetails?.length == 0) {
      toast.error("Physical Details is Empty");
      return;
    }
    try {
      physicalDetails.map((row) => {
        if (row.inputtype == "input") {

          if (!row?.FieldOfficerValue) {
            throw new Error(
              `Please Enter Field Officer Input for ${row.label}`
            );
          }
          if (row?.FieldOfficerValue?.trim()?.length == 0) {
            throw new Error(
              `Please Enter Field Officer Input for ${row.label}`
            );
          }
        }
        if (row.inputtype == "checkbox") {
          if (!row?.Yes && !row.No) {
            throw new Error(
              `Please Select Field Officer Input for ${row.label}`
            );
          }
        }
        if (!row?.Pass && !row.Fail) {
          throw new Error(`Please Select Status for ${row.label}`);
        }
      });
    } catch (err) {
      toast.error(err.message);
      return;
    }
    if (deficiencies) {
      if (deficiencies?.trim()?.length == 0) {
        toast.error("Please Enter Valid Deficiencies");
        return;
      }
    }
    if (!roleCheckBoxData.candidateFit && !roleCheckBoxData.candidateNotFit) {
      toast.error("Please Select Candidate Fitness");
      return;
    }
    if (roleCheckBoxData.candidateNotFit) {
      if (!rejectReason) {
        toast.error("Please Select Reject Reason");
        return;
      }
    }
    if (remarks) {
      if (remarks?.trim()?.length == 0) {
        toast.error("Please Enter Valid Remarks");
        return;
      }
    }

    setTakePhysicalModal(false);
    setConfomationModal(true);
  };
  const CloseConfomationModal = () => {
    setConfomationModal(false);
    setTakePhysicalModal(true);
  };
  const UpdateConformed = async () => {
    let userids =localStorage.getItem("@userid");

    if(!userids){
      toast.error("Something went wrong please try again");
      return
    }
    if(!Selectedtests?.physical_test_id){
      toast.error("Something went wrong please try again");
      return
    }
    try {
      let url = "application/updatephysical";
      let method = "PUT";
      let params = {
        physical_test_id: Selectedtests.physical_test_id,
        test_name: "Physical Verification",
        status: roleCheckBoxData.candidateNotFit? "rejected":"approved",
        created_by:userids ,
        location:ExaminedPlace,
        test_data: physicalDetails,
        remarks: remarks,
        deficiencies:deficiencies,
        attachment: [{ name: "", attachment: "" }],
        reject_reason:rejectReason
      };
 
      setLoading(true);
      const response = await PostMethod({ url, method, params });
    
      if (response.status) {
        setLoading(false);
        setConfomationModal(false);
        UpdateCandicateCerificate();
      } else {
        setLoading(false);
        if (response.message) {
          toast.error();
        } else {
          toast.error("Something went wrong please try again");
        }
      }
    } catch (Error) {
      setLoading(false);
      toast.error("Something went wrong please try again");
    }
  };
  const HandlePhysicalFieldValueChanges = (value, i) => {
    let details = [...physicalDetails];
    details[i].FieldOfficerValue = value;
    setPhysicalDetails(details);
  };
  const HandlePhysicalFieldValueChange = (i, value) => {
    let details = [...physicalDetails];
    if (value == "Pass") {
      details[i].Pass = true;
      details[i].Fail = false;
    } else {
      details[i].Pass = false;
      details[i].Fail = true;
    }
    setPhysicalDetails(details);
  };
  const HandlePhysicalFieldValue = (i, value) => {
    const datas = [...physicalDetails];
    datas[i].FieldOfficerValue = value;

    setPhysicalDetails(datas);
  };
  const OpenCerticateImage1 = async(row, i) => {
    setCertificateVerifyModal(false)
    setCertificateImageModal(true)
    let URL  =await GetPublicURL(row.fileUrl)
    setfileExtentions(String(row.fileUrl).split(".").pop())
    setImageUrl(URL);
    setCertificateName(row.attachmentName)
    setSelectedIndex(i);
    setCertificateSelectList({ "Yes": row?.verified, "No": row.unVerified })
  }
  const CloseCerticateImage = () => {
    setCertificateVerifyModal(true)
    setCertificateImageModal(false)
    setImageUrl("");
    setCertificateName("")
    setSelectedIndex("")
  }
  const UpdateCerficate = () => {
   
    CloseCerticateImage()
  }
  return (
    <Grid item>
      <RightSideModal
        open={takePhysicalModal}
        setOpen={ClosePhysicalModal}
        width={"40%"}
        scroll={true}
        height={"90vh"}
        modalTitle={
          <h4 className="poppinsSemiBold Text-Prime-Black text-left">
            Take Physical Data Details
          </h4>
        }
        modalContent={
          <Grid item lg={12} md={12} sm={12} xs={12} className="px-2">
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              className="p-2"
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid
                item
                lg={9}
                sm={9}
                md={9}
                xs={9}
                container
                alignItems={"center"}
              >
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name of the Post Applying for
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.job_name
                        ? applicationDetail?.job_name
                        : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Notification Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.notificationNumer
                        ? applicationDetail?.notificationNumer
                        : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Application Number
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail?.application_serial
                        ? applicationDetail?.application_serial
                        : "--"}
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  style={{ borderBottom: "2px dotted black" }}
                />
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  justifyContent={"space-between"}
                >
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Name
                    </p>
                  </Grid>
                  <Grid item lg={6} sm={6} md={6} xs={6}>
                    <p className="poppinsRegular Text-Prime-Black text-left">
                      {applicationDetail.salutation
                        ? applicationDetail.salutation
                        : ""}{" "}
                      {applicationDetail.name ? applicationDetail.name : "--"}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                lg={2}
                sm={2}
                md={2}
                xs={2}
                container
                justifyContent={"flex-end"}
              >
                {applicant_image&& <img
                  src={applicant_image}
                  alt="PSCLogo"
                  height={150}
                  width={150}
                  className="img_fluid"
                />}
              </Grid>
            </Grid>
            <Grid
              item
              lg={12}
              sm={12}
              md={12}
              xs={12}
              container
              className="p-2"
            >
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                flexDirection={"row"}
                alignItems={"center"}
              >
                <h5 className="poppinsSemiBold Text-Prime-Black text-left">
                  Physical Test Assessment
                </h5>
                <Grid item className="w-20 mx-2">
                  <p style={{textTransform:"capitalize"}} className={StatusStyle(Selectedtests?.physical_test_current_status )}>{Selectedtests?.physical_test_current_status ? Selectedtests?.physical_test_current_status :""}</p>
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12}>
                <TableContainer className="mt-3">
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell align="center">Physical Data</StyledTableCell>
                        <StyledTableCell align="center" >From Candidate</StyledTableCell>
                        <StyledTableCell align="center" > Field Officer Input </StyledTableCell>
                        <StyledTableCell align="center">Status</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {physicalDetails?.map((item, i) => {
                        return (
                          <StyledTableRow key={i}>
                            <StyledTableCell align="center">
                              <p className="poppinsRegular Text-Prime-Black">
                                {item.name}
                              </p>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <p className="poppinsRegular Text-Prime-Black">
                                {item.value ? item.value : "--"}
                              </p>
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {isEdit ? (
                                item.input == "text" ? (
                                  <CustomInput
                                    placeholder={`Enter ${item.name}`}
                                    backgroundColor="#FFFFFF"
                                    width={"100%"}
                                    maxLength={50}
                                    height={"45px"}
                                    padding={"2.5% 3% 2.5% 0%"}
                                    border={"1px solid #666666"}
                                    fontFamily={"PoppinsMedium"}
                                    value={item.FieldOfficerValue}
                                    onChange={(e) =>
                                      HandlePhysicalFieldValueChanges(
                                        e.target.value,
                                        i
                                      )
                                    }
                                  />
                                ) : (
                                  item.input == "check" && (
                                    <Grid
                                      item
                                      lg={12}
                                      sm={12}
                                      md={12}
                                      xs={12}
                                      display={"flex"}
                                      alignItems={"center"}
                                      flexDirection={"row"}
                                      justifyContent={"center"}
                                    >
                                      <Grid
                                        item
                                        lg={6}
                                        sm={6}
                                        md={6}
                                        xs={6}
                                        container
                                        alignItems={"center"}
                                        flexDirection={"row"}
                                      >
                                        <CustomCheckBox
                                          className={"p-0"}
                                          disableColor={"transparent"}
                                          checked={
                                            item.FieldOfficerValue == "Yes"
                                              ? true
                                              : false
                                          }
                                          onChange={() =>
                                            HandlePhysicalFieldValue(i, "Yes")
                                          }
                                        />
                                        <p className="poppinsRegular Text-Prime-Black text-center">
                                          Yes
                                        </p>
                                      </Grid>
                                      <Grid
                                        item
                                        lg={6}
                                        sm={6}
                                        md={6}
                                        xs={6}
                                        container
                                        alignItems={"center"}
                                        flexDirection={"row"}
                                      >
                                        <CustomCheckBox
                                          className={"p-0"}
                                          disableColor={"transparent"}
                                          checked={
                                            item.FieldOfficerValue == "No"
                                              ? true
                                              : false
                                          }
                                          onChange={() =>
                                            HandlePhysicalFieldValue(i, "No")
                                          }
                                        />
                                        <p className="poppinsRegular Text-Prime-Black text-center">
                                          No
                                        </p>
                                      </Grid>
                                    </Grid>
                                  )
                                )
                              ) : (
                                <p className="poppinsRegular Text-Prime-Black">
                                  {item.value ? item.value : "--"}
                                </p>
                              )}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {isEdit ? (
                                <Grid
                                  item
                                  lg={12}
                                  sm={12}
                                  md={12}
                                  xs={12}
                                  display={"flex"}
                                  alignItems={"center"}
                                  flexDirection={"row"}
                                  justifyContent={"center"}
                                >
                                  <Grid
                                    item
                                    lg={6}
                                    sm={6}
                                    md={6}
                                    xs={6}
                                    container
                                    alignItems={"center"}
                                    flexDirection={"row"}
                                  >
                                    <CustomCheckBox
                                      className={"p-0"}
                                      disableColor={"transparent"}
                                      checked={
                                        item?.Pass == true ? true : false
                                      }
                                      key={i}
                                      onChange={() =>
                                        HandlePhysicalFieldValueChange(
                                          i,
                                          "Pass"
                                        )
                                      }
                                    />
                                    <p className="poppinsRegular Text-Prime-Black text-center">
                                      Pass
                                    </p>
                                  </Grid>
                                  <Grid
                                    item
                                    lg={6}
                                    sm={6}
                                    md={6}
                                    xs={6}
                                    container
                                    alignItems={"center"}
                                    flexDirection={"row"}
                                  >
                                    <CustomCheckBox
                                      className={"p-0"}
                                      disableColor={"transparent"}
                                      checked={
                                        item?.Fail == true ? true : false
                                      }
                                      key={i}
                                      onChange={() =>
                                        HandlePhysicalFieldValueChange(
                                          i,
                                          "Fail"
                                        )
                                      }
                                    />
                                    <p className="poppinsRegular Text-Prime-Black text-center">
                                      Fail
                                    </p>
                                  </Grid>
                                </Grid>
                              ) : item.Pass ? (
                                <p className="poppinsRegular Text-Prime-Green text-center">
                                  Pass
                                </p>
                              ) : (
                                <p className="poppinsRegular Text-Prime-Red text-center">
                                  Fail
                                </p>
                              )}
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="py-2"
                flexDirection={"column"}
              >
                <Grid item container>
                  <p className="poppinsMedium Text-Prime-Black text-left w-100">
                    If Any Other Deficiencies
                  </p>
                </Grid>

                <Grid item className="py-2" container>
                  {isEdit ? (
                    <TextAreaField
                      placeholder="Enter the Deficiencies If Any"
                      fontSize={14}
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      maxLength={1000}
                      padding={"2.5% 3% 2.5% 0%"}
                      placeholderColor="#666666"
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      value={deficiencies}
                      onChange={(e) => setDeficiencies(e.target.value)}
                    />
                  ) : (
                    <p className="poppinsRegular Text-Prime-Black text-left px-2">
                      this is Deficiencies from anto the Deficiencies If Any
                    </p>
                  )}
                </Grid>
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" >
                <TableContainer >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>Certificate / Report Name</StyledTableCell>
                        <StyledTableCell>Attachment</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {attachmentNewList?.map((row, i) => {
                        return (
                          <StyledTableRow key={i}>
                            <StyledTableCell align="left">
                              <p className="poppinsMedium Text-Prime-Black text-left w-100 text-capitalize">
                                {row.attachmentName}
                              </p>
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              <p className={"TextUnderGreen pointer poppinsRegular"} role="presentation" 
                                onClick={() => OpenCerticateImage1({ ...row, level: row.attachmentName })}
                              >
                                View File
                              </p>

                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Divider
                className="mt-2 mb-2 w-100"
                sx={{ border: "1px solid #a7aba96e" }}
              />
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                display={"flex"}
                alignItems={"center"}
                flexDirection={"row"}
                className="py-2"
              >
                <Grid
                  item
                  lg={6}
                  sm={6}
                  md={6}
                  xs={6}
                  container
                  alignItems={"center"}
                  flexDirection={"row"}
                >
                  <CustomCheckBox
                    className={"p-0"}
                    disableColor={"transparent"}
                    checked={roleCheckBoxData?.candidateFit || !isEdit}
                    onChange={() =>
                      isEdit &&
                      HandleChandidateChange(
                        !roleCheckBoxData.candidateFit,
                        "candidateFit"
                      )
                    }
                  />
                  <p className="poppinsRegular Text-Prime-Black text-left px-2">
                    Mark as Candidate as Fit for this Role
                  </p>
                </Grid>
                {isEdit && (
                  <Grid
                    item
                    lg={6}
                    sm={6}
                    md={6}
                    xs={6}
                    container
                    alignItems={"center"}
                    flexDirection={"row"}
                  >
                    <CustomCheckBox
                      className={"p-0"}
                      disableColor={"transparent"}
                      checked={roleCheckBoxData?.candidateNotFit}
                      onChange={() =>
                        HandleChandidateChange(
                          !roleCheckBoxData.candidateNotFit,
                          "candidateNotFit"
                        )
                      }
                    />
                    <p className="poppinsRegular Text-Prime-Black text-left px-2">
                      Mark as Candidate as not Fit for this Role
                    </p>
                  </Grid>
                )}
              </Grid>
              {(Selectedtests?.physical_test_current_status=="rejected") && (
                <Grid
                  item
                  lg={12}
                  sm={12}
                  md={12}
                  xs={12}
                  container
                  className="py-2"
                  flexDirection={"column"}
                >
                  <Grid item container>
                    <p className="poppinsMedium Text-Prime-Black text-left w-100">
                      Reason for Rejection
                    </p>
                  </Grid>
                  <Grid item className="py-2 w-50">
                    {isEdit ? (
                      <CustomDropDown
                        placeholder={"Please Select Reason"}
                        borderRadius={"8px"}
                        data={RejectionsInfo}
                        selected={
                          rejectReason && {
                            label: rejectReason,
                            value: rejectReason,
                          }
                        }
                        onChange={(option) => {
                          setRejectReason(option?.value);
                          setRemarks("");
                        }}
                      />
                    ) : (
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        Education Qualification Not Met
                      </p>
                    )}
                  </Grid>
                </Grid>
              )}
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                className="py-2"
                flexDirection={"column"}
              >
                <Grid item container>
                  <p className="poppinsMedium Text-Prime-Black text-left w-100">
                    Remarks
                  </p>
                </Grid>
                <Grid item className="py-2" container>
                  {isEdit ? (
                    <TextAreaField
                      placeholder="Enter the Remarks If Any"
                      fontSize={14}
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      maxLength={1000}
                      padding={"2.5% 3% 2.5% 0%"}
                      placeholderColor="#666666"
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                    />
                  ) : (
                    <p className="poppinsRegular Text-Prime-Black text-left px-2 text-capitalize">
                      {remarks? remarks:"---"}
                    </p>
                  )}
                </Grid>
              </Grid>
              <Grid
                item
                lg={12}
                sm={12}
                md={12}
                xs={12}
                container
                alignItems={"flex-start"}
                justifyContent={"space-between"}
              >
                <Grid
                  item
                  lg={5.9}
                  sm={5.9}
                  md={5.9}
                  xs={5.9}
                  container
                  alignItems={"center"}
                >
                  <Grid
                    item
                    lg={12}
                    sm={12}
                    md={12}
                    xs={12}
                    container
                    className="py-2"
                    justifyContent={"space-between"}
                  >
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Examined by
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsRegular Text-Prime-Black text-left">
                        {userid?.first_name} {userid?.last_name}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={5.9}
                  sm={5.9}
                  md={5.9}
                  xs={5.9}
                  container
                  alignItems={"center"}
                >
                  <Grid
                    item
                    lg={12}
                    sm={12}
                    md={12}
                    xs={12}
                    container
                    className="py-2"
                    justifyContent={"space-between"}
                  >
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      <p className="poppinsMedium Text-Prime-Black text-left">
                        Examined on
                      </p>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={6}>
                      {!isEdit && <p className="poppinsRegular Text-Prime-Black text-left">
                        {OnlyDateTimeConverter(Number(Selectedtests?.physical_test_examined_at))}
                      </p>}
                      {isEdit && <p className="poppinsRegular Text-Prime-Black text-left">
                        {OnlyDateTimeConverter(Date.now())}
                      </p>}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={12} sm={12} md={12} xs={12} container>
                  <Grid
                    item
                    lg={6}
                    sm={6}
                    md={6}
                    xs={6}
                    container
                    className="py-2"
                    flexDirection={"column"}
                  >
                    <p className="poppinsMedium Text-Prime-Black text-left">
                      Examined Place
                    </p>

                    {isEdit&& 
                    <p className="poppinsRegular Text-Prime-Black text-left pt-2">
                      {ExaminedPlace? ExaminedPlace:"---" }
                    </p>
                    }
                    {!isEdit &&<p className="poppinsRegular Text-Prime-Black text-left pt-2">
                      {Selectedtests?.physical_test_examined_location}
                    </p> }
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
        modalFooter={
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            container
            justifyContent={"flex-end"}
          >
            <PrimeGrayBorderColorButton
              type="submit"
              className="px-3 py-2"
              onClick={() => ClosePhysicalModal()}
            >
              Close
            </PrimeGrayBorderColorButton>
            {isEdit && (
              <GreenColorButton
                type="submit"
                className="px-3 py-2 ml-3"
                onClick={() => UpdateModalPhysicalData()}
              >
                Update
                {Loading && (
                  <CircularProgress size="1rem" style={{ color: "#fff" }} />
                )}
              </GreenColorButton>
            )}
          </Grid>
        }
      />
      <CustomModal
        open={confomationModal}
        setOpen={CloseConfomationModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CiCircleQuestion color={"#12A59B"} size={100} />
            <p className="poppinsRegular Text-Prime-Black pt-3 text-center">
              Are you sure you want to update this candidate’s physical data ?
            </p>
            <p className="poppinsLight Text-Prime-Gray pt-3 text-center">
              Ensure all details are accurate before update.
            </p>
            <Grid
              item
              container
              display={"flex"}
              justifyContent={"center"}
              sx={{ marginTop: "6%" }}
            >
              <PrimeGrayBorderColorButton
                type="submit"
                className="px-5 py-2"
                onClick={() => CloseConfomationModal()}
              >
                No
              </PrimeGrayBorderColorButton>
              <DarkGreenColorButton
                type="submit"
                className="px-5 py-2 ml-2"
                onClick={() => UpdateConformed()}
              >
                Yes{" "}
                {Loading && (
                  <CircularProgress size="1rem" style={{ color: "#fff" }} />
                )}
              </DarkGreenColorButton>
            </Grid>
          </Grid>
        }
      />
      < CerificateModal
        certificateImageModal={certificateImageModal}
        setCertificateImageModal={setCertificateImageModal}
        CloseCerticateImage={CloseCerticateImage}
        imageUrl={imageUrl}
        fileExtentions={fileExtentions}
        certificateName={certificateName}
        isEdit={isEdit}
        selectedIndex={selectedIndex}
        UpdateCerficate={UpdateCerficate}
        certificateSelectList={certificateSelectList}
        setCertificateSelectList={setCertificateSelectList}
      />
    </Grid>
  );
};

export default TakePhysicalDataDetails;
